import React from 'react';
import { PracticeInfo } from '../api/bookingApi';

interface ApptTypeStepProps {
  practiceInfo: PracticeInfo | null;
  onSelected: (apptType: string) => void;
  onBack: () => void;
}

export default function ApptTypeStep({ practiceInfo, onSelected, onBack }: ApptTypeStepProps) {
  const apptTypes = practiceInfo?.appointment_types ?? [];

  return (
    <div>
      <div className="text-center mb-6">
        <h2 className="text-2xl font-bold text-gray-900">Choose appointment type</h2>
        <p className="text-gray-500 mt-1">What type of appointment do you need?</p>
      </div>

      {apptTypes.length === 0 ? (
        <div className="text-center py-8">
          <p className="text-gray-600">Please call us to schedule your appointment.</p>
          {practiceInfo?.phone_number && (
            <a
              href={`tel:${practiceInfo.phone_number.replace(/[^\d+]/g, '')}`}
              className="inline-block mt-3 text-base font-semibold text-sky-600 hover:text-sky-700"
            >
              {practiceInfo.phone_number}
            </a>
          )}
        </div>
      ) : (
        <div className="flex flex-col gap-3">
          {apptTypes.map((t) => (
            <button
              key={t.key}
              onClick={() => onSelected(t.key)}
              className="w-full py-3 px-4 text-left font-medium rounded-lg border border-border bg-card text-foreground hover:border-primary hover:text-primary-deep transition-colors flex items-center justify-between"
            >
              <span>{t.name}</span>
              {t.duration_minutes != null && (
                <span className="text-sm font-normal text-gray-500 ml-2">{t.duration_minutes} min</span>
              )}
            </button>
          ))}
        </div>
      )}

      <button
        type="button"
        onClick={onBack}
        className="mt-6 text-sm text-gray-500 hover:text-gray-700 underline"
      >
        Back
      </button>
    </div>
  );
}
